import type { BadgeProps as MantineBadgeProps } from '@mantine/core';
import { DataQualityClassification } from '@repo/common/enums/dataQualityClassification';
import type { BadgeVariant } from '@repo/foundations';
import { Badge } from '@repo/foundations';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

const BADGE_VARIANT: Record<DataQualityClassification, BadgeVariant> = {
	[DataQualityClassification.GREAT]: 'success',
	[DataQualityClassification.GOOD]: 'info',
	[DataQualityClassification.MODERATE]: 'attention',
	[DataQualityClassification.POOR]: 'poor',
	[DataQualityClassification.UNAVAILABLE]: 'default',
};

export interface DataQualityBadgeProps
	extends Omit<MantineBadgeProps, 'variant' | 'color'> {
	classification: DataQualityClassification;
}

export const DataQualityBadge = forwardRef(
	(
		{ classification, ...props }: DataQualityBadgeProps,
		ref: ForwardedRef<HTMLDivElement>
	) => (
		<Badge ref={ref} variant={BADGE_VARIANT[classification]} {...props}>
			{classification}
		</Badge>
	)
);
DataQualityBadge.displayName = 'DataQualityBadge';
